import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { apiClient } from "@/api/endpoints";
import { SelskapContextProvider } from "@/features/auth/SelskapContext";
import { ToasterProvider } from "@/features/toaster";

export const Route = createFileRoute("/_app")({
  component: AppLayoutComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        // TODO password : Endre tilbake til "/auth/login" når passordbeskyttelse er fjernet
        to: "/auth/logg-inn",
        throw: true,
      });
    }
  },
});

function AppLayoutComponent() {
  return (
    <SelskapContextProvider>
      <SetupCSRFToken />
      {/* <div> Sørger for at Toaster havner på rett plass */}
      <div>
        <ToasterProvider />
        <Outlet />
      </div>
    </SelskapContextProvider>
  );
}

function SetupCSRFToken() {
  useEffect(() => {
    apiClient.auth.setupCsrfToken();
  }, []);

  return null;
}
